<template>
    <div id="mission-form">
        <v-card v-for="kelas in kelasList" :key="kelas" flat>
            <v-card-actions>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Kelas
                        </v-list-item-title>
                        <v-text-field :value="kelas" outlined disabled filled />
                    </v-list-item-content>
                </v-list-item>
                <v-spacer></v-spacer>
                <v-btn icon @click="expanded[kelas] = !expanded[kelas]">
                    <v-icon>{{ expanded[kelas] ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                </v-btn>
            </v-card-actions>

            <v-expand-transition>
                <div v-show="expanded[kelas]" class="mx-5">

                    <!-- LOOP MISSIONS -->
                    <div v-for="(mission, mIndex) in missionsTemplate" :key="mIndex">
                        <!-- Fitur name -->
                        <v-list-item class="pa-0 mt-5">
                            <v-row>
                                <v-col>
                                    <v-list-item two-line class="pa-0">
                                        <v-list-item-content class="pa-0">
                                            <v-list-item-title class="font-weight-bold pb-2">Fitur</v-list-item-title>
                                            <v-text-field :value="mission.name" outlined filled disabled />
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                        </v-list-item>

                        <!-- Weekly / Daily checkboxes -->
                        <v-list-item class="pa-0">
                            <v-row>
                                <v-col>
                                    <v-row>
                                        <v-col>
                                            <v-checkbox v-model="mission.is_weekly" label="Weekly"
                                                @change="handleWeeklyChange(mission)" />
                                        </v-col>
                                        <v-col>
                                            <v-checkbox v-model="mission.is_daily" label="Daily"
                                                @change="handleDailyChange(mission)" />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-list-item>

                        <!-- DAILY inputs -->
                        <v-list-item v-if="mission.is_daily" class="pa-0">
                            <v-row>
                                <v-col>
                                    <v-text-field v-model="mission.daily_target" label="Misi per hari" outlined />
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="mission.poin_daily" label="Poin per hari" outlined />
                                </v-col>
                            </v-row>
                        </v-list-item>

                        <!-- WEEKLY inputs -->
                        <v-list-item v-if="mission.is_weekly" class="pa-0">
                            <v-row>
                                <v-col>
                                    <v-text-field v-model="mission.week_one_target" label="Misi Minggu 1" outlined />
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="mission.week_two_target" label="Misi Minggu 2" outlined />
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="mission.week_three_target" label="Misi Minggu 3" outlined />
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="mission.week_four_target" label="Misi Minggu 4" outlined />
                                </v-col>
                            </v-row>
                        </v-list-item>

                        <v-list-item v-if="mission.is_weekly" two-line class="pa-0">
                            <v-list-item-content class="pa-0">
                                <v-list-item-title class="font-weight-bold pb-2">Poin per minggu</v-list-item-title>
                                <v-text-field v-model="mission.poin_weekly" outlined />
                            </v-list-item-content>
                        </v-list-item>

                        <v-divider></v-divider>
                    </div>

                    <!-- Save button -->
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="submit(kelas)">
                            Simpan Misi Kelas {{ kelas }}
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-expand-transition>
        </v-card>


        <v-card-actions class="mt-5">
            <v-spacer></v-spacer>
            <v-btn @click="$emit('uncompleted')" depressed text>
                Kembali
            </v-btn>

            <v-btn color="blew" type="button" class="btn btn-success pull-right" @click="$emit('completed')" depressed
                dark>
                Selanjutnya
            </v-btn>
        </v-card-actions>
        </v-card>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import Spinner from "@/modules/global/components/plugins/Spinner";
import AmbisMeterService from "@/modules/ambis_meter/services/ambis_meter.js";

export default {
    name: "mission-form",

    components: {
        "app-spinner": Spinner,
    },

    data() {
        return {
            isLoading: false,
            errors: [],
            expanded: {}, // holds toggles for each kelas
            periode_id: this.$route.query.id,
            kelasList: [4, 5, 6, 7, 8, 9, 10, 11, 12],
            missionsTemplate: [
                {
                    id: 1,
                    mission_id: 0,
                    name: "Try Out",
                    is_daily: false,
                    poin_daily: 0,
                    daily_target: 0,
                    is_weekly: false,
                    poin_weekly: 0,
                    week_one_target: 0,
                    week_two_target: 0,
                    week_three_target: 0,
                    week_four_target: 0,
                },
                {
                    id: 2,
                    mission_id: 0,
                    name: "Live Class",
                    is_daily: false,
                    poin_daily: 0,
                    daily_target: 0,
                    is_weekly: false,
                    poin_weekly: 0,
                    week_one_target: 0,
                    week_two_target: 0,
                    week_three_target: 0,
                    week_four_target: 0,
                },
                {
                    id: 3,
                    mission_id: 0,
                    name: "Video",
                    is_daily: false,
                    poin_daily: 0,
                    daily_target: 0,
                    is_weekly: false,
                    poin_weekly: 0,
                    week_one_target: 0,
                    week_two_target: 0,
                    week_three_target: 0,
                    week_four_target: 0,
                },
                {
                    id: 4,
                    mission_id: 0,
                    name: "Ambis Recharge",
                    is_daily: false,
                    poin_daily: 0,
                    daily_target: 0,
                    is_weekly: false,
                    poin_weekly: 0,
                    week_one_target: 0,
                    week_two_target: 0,
                    week_three_target: 0,
                    week_four_target: 0,
                },
                {
                    id: 5,
                    mission_id: 0,
                    name: "Konsultasi",
                    is_daily: false,
                    poin_daily: 0,
                    daily_target: 0,
                    is_weekly: false,
                    poin_weekly: 0,
                    week_one_target: 0,
                    week_two_target: 0,
                    week_three_target: 0,
                    week_four_target: 0,
                },
                {
                    id: 6,
                    mission_id: 0,
                    name: "Latihan Soal",
                    is_daily: false,
                    poin_daily: 0,
                    daily_target: 0,
                    is_weekly: false,
                    poin_weekly: 0,
                    week_one_target: 0,
                    week_two_target: 0,
                    week_three_target: 0,
                    week_four_target: 0,
                },
                {
                    id: 7,
                    mission_id: 0,
                    name: "Modul",
                    is_daily: false,
                    poin_daily: 0,
                    daily_target: 0,
                    is_weekly: false,
                    poin_weekly: 0,
                    week_one_target: 0,
                    week_two_target: 0,
                    week_three_target: 0,
                    week_four_target: 0,
                }
            ],
        }
    },
    created() {
        // initialize expanded toggles
        this.kelasList.forEach(k => this.$set(this.expanded, k, false))
    },

    mounted() {
        if (this.$route.query.id) {
            this.getDetailMission();
        }
    },

    methods: {
        async getDetailMission() {
            const context = this;
            context.isLoading = true;
            await AmbisMeterService.getMissionDetail(
                this.$route.query.id,
                function (response) {
                    if (response.success) {
                        response.data.forEach((result) => {
                            context.missions.forEach((misi) => {
                                if (result.feature_id === misi.id) {
                                    (misi.mission_id = result.id),
                                        (misi.is_daily = result.is_daily),
                                        (misi.poin_daily = result.poin_daily),
                                        (misi.daily_target =
                                            result.daily_target),
                                        (misi.is_weekly = result.is_weekly),
                                        (misi.poin_weekly = result.poin_weekly),
                                        (misi.week_one_target =
                                            result.week_one_target),
                                        (misi.week_two_target =
                                            result.week_two_target),
                                        (misi.week_three_target =
                                            result.week_three_target),
                                        (misi.week_four_target =
                                            result.week_four_target);
                                } else if (
                                    result.feature_id === 0 ||
                                    result.feature_id === null ||
                                    result.feature_id === undefined
                                ) {
                                    (misi.id = misi.id),
                                        (misi.mission_id = result.id),
                                        (misi.is_daily = result.is_daily),
                                        (misi.poin_daily = result.poin_daily),
                                        (misi.daily_target =
                                            result.daily_target),
                                        (misi.is_weekly = result.is_weekly),
                                        (misi.poin_weekly = result.poin_weekly),
                                        (misi.week_one_target =
                                            result.week_one_target),
                                        (misi.week_two_target =
                                            result.week_two_target),
                                        (misi.week_three_target =
                                            result.week_three_target),
                                        (misi.week_four_target =
                                            result.week_four_target);
                                }
                            });
                        });
                    }
                    context.isLoading = false;
                }
            );
        },

        handleWeeklyChange(mission) {
            if (!mission.is_weekly) {
                mission.poin_weekly = 0;
                mission.week_one_target = 0;
                mission.week_two_target = 0;
                mission.week_three_target = 0;
                mission.week_four_target = 0;
            }
        },
        handleDailyChange(mission) {
            if (!mission.is_daily) {
                mission.poin_daily = 0;
                mission.daily_target = 0;
            }
        },

        submit: function (kelas) {
            var context = this;
            var soal_rekomendasi = {
                id: this.missionsTemplate[0].mission_id,
                kelas: kelas,
                feature_id: 1,
                periode_id: this.$store.state.ambismeter.id,
                is_daily: this.missionsTemplate[0].is_daily,
                poin_daily: parseFloat(this.missionsTemplate[0].poin_daily),
                daily_target: parseFloat(this.missionsTemplate[0].daily_target),
                is_weekly: this.missionsTemplate[0].is_weekly,
                poin_weekly: parseFloat(this.missionsTemplate[0].poin_weekly),
                week_one_target: parseFloat(this.missionsTemplate[0].week_one_target),
                week_two_target: parseFloat(this.missionsTemplate[0].week_two_target),
                week_three_target: parseFloat(
                    this.missionsTemplate[0].week_three_target
                ),
                week_four_target: parseFloat(this.missionsTemplate[0].week_four_target),
            };
            var live_class = {
                id: this.missionsTemplate[1].mission_id,
                feature_id: 2,
                kelas: kelas,
                periode_id: this.$store.state.ambismeter.id,
                is_daily: this.missionsTemplate[0].is_daily,
                poin_daily: parseFloat(this.missionsTemplate[0].poin_daily),
                daily_target: parseFloat(this.missionsTemplate[0].daily_target),
                is_weekly: this.missionsTemplate[1].is_weekly,
                poin_weekly: parseFloat(this.missionsTemplate[1].poin_weekly),
                week_one_target: parseFloat(this.missionsTemplate[1].week_one_target),
                week_two_target: parseFloat(this.missionsTemplate[1].week_two_target),
                week_three_target: parseFloat(
                    this.missionsTemplate[1].week_three_target
                ),
                week_four_target: parseFloat(this.missionsTemplate[1].week_four_target),
            };
            var video = {
                id: this.missionsTemplate[2].mission_id,
                feature_id: 3,
                kelas: kelas,
                periode_id: this.$store.state.ambismeter.id,
                is_daily: this.missionsTemplate[2].is_daily,
                poin_daily: parseFloat(this.missionsTemplate[2].poin_daily),
                daily_target: parseFloat(this.missionsTemplate[2].daily_target),
                is_weekly: this.missionsTemplate[2].is_weekly,
                poin_weekly: parseFloat(this.missionsTemplate[2].poin_weekly),
                week_one_target: parseFloat(this.missionsTemplate[2].week_one_target),
                week_two_target: parseFloat(this.missionsTemplate[2].week_two_target),
                week_three_target: parseFloat(
                    this.missionsTemplate[2].week_three_target
                ),
                week_four_target: parseFloat(this.missionsTemplate[2].week_four_target),
            };
            var ambis_recharge = {
                id: this.missionsTemplate[3].mission_id,
                feature_id: 4,
                kelas: kelas,
                periode_id: this.$store.state.ambismeter.id,
                is_daily: this.missionsTemplate[0].is_daily,
                poin_daily: parseFloat(this.missionsTemplate[0].poin_daily),
                daily_target: parseFloat(this.missionsTemplate[0].daily_target),
                is_weekly: this.missionsTemplate[3].is_weekly,
                poin_weekly: parseFloat(this.missionsTemplate[3].poin_weekly),
                week_one_target: parseFloat(this.missionsTemplate[3].week_one_target),
                week_two_target: parseFloat(this.missionsTemplate[3].week_two_target),
                week_three_target: parseFloat(
                    this.missionsTemplate[3].week_three_target
                ),
                week_four_target: parseFloat(this.missionsTemplate[3].week_four_target),
            };
            var konsultasi = {
                id: this.missionsTemplate[4].mission_id,
                feature_id: 5,
                kelas: kelas,
                periode_id: this.$store.state.ambismeter.id,
                is_daily: this.missionsTemplate[4].is_daily,
                poin_daily: parseFloat(this.missionsTemplate[4].poin_daily),
                daily_target: parseFloat(this.missionsTemplate[4].daily_target),
                is_weekly: this.missionsTemplate[4].is_weekly,
                poin_weekly: parseFloat(this.missionsTemplate[4].poin_weekly),
                week_one_target: parseFloat(this.missionsTemplate[4].week_one_target),
                week_two_target: parseFloat(this.missionsTemplate[4].week_two_target),
                week_three_target: parseFloat(
                    this.missionsTemplate[4].week_three_target
                ),
                week_four_target: parseFloat(this.missionsTemplate[4].week_four_target),
            };
            var latihan_soal = {
                id: this.missionsTemplate[5].mission_id,
                feature_id: 6,
                kelas: kelas,
                periode_id: this.$store.state.ambismeter.id,
                is_daily: this.missionsTemplate[5].is_daily,
                poin_daily: parseFloat(this.missionsTemplate[5].poin_daily),
                daily_target: parseFloat(this.missionsTemplate[5].daily_target),
                is_weekly: this.missionsTemplate[5].is_weekly,
                poin_weekly: parseFloat(this.missionsTemplate[5].poin_weekly),
                week_one_target: parseFloat(this.missionsTemplate[5].week_one_target),
                week_two_target: parseFloat(this.missionsTemplate[5].week_two_target),
                week_three_target: parseFloat(
                    this.missionsTemplate[5].week_three_target
                ),
                week_four_target: parseFloat(this.missionsTemplate[5].week_four_target),
            };

            var modul = {
                id: this.missionsTemplate[6].mission_id,
                feature_id: 7,
                kelas: kelas,
                periode_id: this.$store.state.ambismeter.id,
                is_daily: this.missionsTemplate[6].is_daily,
                poin_daily: parseFloat(this.missionsTemplate[6].poin_daily),
                daily_target: parseFloat(this.missionsTemplate[6].daily_target),
                is_weekly: this.missionsTemplate[6].is_weekly,
                poin_weekly: parseFloat(this.missionsTemplate[6].poin_weekly),
                week_one_target: parseFloat(this.missionsTemplate[6].week_one_target),
                week_two_target: parseFloat(this.missionsTemplate[6].week_two_target),
                week_three_target: parseFloat(
                    this.missionsTemplate[6].week_three_target
                ),
                week_four_target: parseFloat(this.missionsTemplate[6].week_four_target),
            };

            var arrayLevel = [
                soal_rekomendasi,
                live_class,
                video,
                ambis_recharge,
                konsultasi,
                latihan_soal,
                modul,
            ];

            context.isLoading = true;
            AmbisMeterService.addMission(arrayLevel, function (result) {
                if (result.success) {
                    context.$store.commit("showAlert", {
                        message:
                            `Misi Kelas ` + kelas + ` telah berhasil disimpan!`,
                        type: "success",
                    });
                } else {
                    context.$store.commit("showAlert", {
                        message: `Gagal menyimpan misi!`,
                        type: "error",
                    });
                }
                context.isLoading = false;
            });

            // if (!this.$route.query.id) {
            //     AmbisMeterService.addMission(arrayLevel, function (result) {
            //         if (result.success) {
            //             context.$store.commit("showAlert", {
            //                 message:
            //                     `Misi Kelas ` +
            //                     kelas +
            //                     ` telah berhasil disimpan!`,
            //                 type: "success",
            //             });
            //         } else {
            //             context.$store.commit("showAlert", {
            //                 message: `Gagal menyimpan misi!`,
            //                 type: "error",
            //             });
            //         }
            //     });
            //     context.isLoading = false;
            // } else {
            //     AmbisMeterService.updateMission(
            //         this.$route.query.id,
            //         kelas,
            //         arrayLevel,
            //         function (result) {
            //             if (result.success) {
            //                 context.$store.commit("showAlert", {
            //                     message:
            //                         `Misi Kelas ` +
            //                         kelas +
            //                         ` telah berhasil diubah!`,
            //                     type: "success",
            //                 });
            //             } else {
            //                 context.$store.commit("showAlert", {
            //                     message: `Gagal update misi!`,
            //                     type: "error",
            //                 });
            //             }
            //         }
            //     );
            //     context.isLoading = false;
            // }
        },
    },
};
</script>



// WEBPACK FOOTER //
// MissionForm.vue?1b8c9dd8